import React from 'react'
import Sidenav from '../../components/sidenav'
import { Box } from '@mui/material'
import NavBar from '../../components/navBar';
import Card from '@mui/material/Card';
import CampaignListTable from '../../tables/obdTable';
import ReUseableButton from '../../Assests/common_button';
import { Link } from 'react-router-dom';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';




const Home = () => {
  return (
    <>
      <NavBar />
      <Box height={100} />
      <Box sx={{ display: 'flex' }}>
        <Sidenav />

        <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
          {/* <div className='user-button'>
            <Link to="/createCampaign" style={{ textDecoration: 'none' }}>
              <ReUseableButton style={{ background: '#1976D2', margin: '0 0 24px 0', color: '#fff', fontFamily: 'Inter', fontSize: 13 }} >
                Create Campaign
              </ReUseableButton>
            </Link>

          </div> */}
          <Card id='gradientCard'  >
            <CampaignListTable />
          </Card>
        </Box>
      </Box>


    </>

  )
}
export default Home
